import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
    const token = localStorage.getItem("careco_token");
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
});

export function setToken(t) {
    if (t) localStorage.setItem("careco_token", t);
    else localStorage.removeItem("careco_token");
}

export function getToken() {
    return localStorage.getItem("careco_token");
}
